import React from 'react'
import ReCAPTCHA from 'react-google-recaptcha'

const DesignBrief = () => {
  return (
    <section className='max-w-screen-xl mx-auto py-5 sm:py-8 px-8 lg:px-0'>
      <form name='design-brief' method='POST' action='/success' data-netlify='true' data-netlify-honeypot='bot-field' netlify-honeypot='bot-field' data-netlify-recaptcha='true'>
        <input type='hidden' name='bot-field' />
        <input type='hidden' name='form-name' value='design-brief' />
        <input type='hidden' name='subject' data-remove-prefix value='New %{formName} submission' />
        <legend className='mb-8'>
          <h2>Website design brief</h2>
        </legend>
        <section className='space-y-4'>
          <label className='block text-lg' htmlFor='company'>
            <h3 className='block'>Tell us about your Business</h3>
          </label>
          <div className='prose dark:prose-invert min-w-full md:grid md:grid-cols-2 md:gap-6'>
            <p>
              It helps to <span className=''>understand what you do</span>. Include a summary of the services or products you provide. <b>Describe to us the very DNA, values and company mission.</b>
            </p>
            <textarea
              className='focus:ring focus:ring-purple-500 shadow border dark:bg-gray-700 dark:border-gray-700 dark:text-indigo-100 rounded w-full py-4 px-5 text-gray-700 leading-tight'
              type='text'
              name='company'
              id='company'
            />
          </div>
        </section>
        <hr className='my-8 dark:border-gray-700' />
        <section className='space-y-4'>
          <label className='block text-lg' htmlFor='audience'>
            <h3 className='block'>Who are your target audience</h3>
          </label>
          <div className='prose dark:prose-invert min-w-full md:grid md:grid-cols-2 md:gap-6'>
            <p>
              Try your best to describe the type of people that the website is targeted at. <b>Describe what your ideal client looks like.</b> This will help us design a site geared towards those
              exact people.
            </p>
            <textarea
              className='focus:ring focus:ring-purple-500 shadow border dark:bg-gray-700 dark:border-gray-700 dark:text-indigo-100 rounded w-full py-4 px-5 text-gray-700 leading-tight'
              type='text'
              name='audience'
              id='audience'
            />
          </div>
        </section>
        <hr className='my-8 dark:border-gray-700' />
        <section className='space-y-4'>
          <label className='block text-lg' htmlFor='goal'>
            <h3 className='block'>What are the Goals of the New Site</h3>
          </label>
          <div className='prose dark:prose-invert min-w-full md:grid md:grid-cols-2 md:gap-6'>
            <p>
              What are the <b>overall aims of the new site?</b> Most often we’ll see a mix of the following:
              <ul>
                <li>Increase brand awareness.</li>
                <li>Improve online presence with a modern, and mobile responsive website design.</li>
                <li>Increase online exposure through natural and paid listings.</li>
                <li>Increase sales.</li>
                <li>Generate leads and enquiries.</li>
                <li>Improved source of information through e-learning or blogs.</li>
                <li>Bespoke requirements for clients i.e. bespoke platforms or services.</li>
              </ul>
              If you think it will be important – include a section about your old site. What works, what doesn't, things to lose, things to retain, what you don’t like about it.
            </p>
            <textarea
              className='focus:ring focus:ring-purple-500 shadow border dark:bg-gray-700 dark:border-gray-700 dark:text-indigo-100 rounded w-full py-4 px-5 text-gray-700 leading-tight'
              type='text'
              name='goal'
              id='goal'
            />
          </div>
        </section>
        <hr className='my-8 dark:border-gray-700' />
        <section className='space-y-4'>
          <label className='block text-lg' htmlFor='competitors'>
            <h3 className='block'>Show us your competitors or sites you like</h3>
          </label>
          <div className='prose dark:prose-invert min-w-full md:grid md:grid-cols-2 md:gap-6'>
            <p>
              Who are your main competitors? We can look at what they’re doing right and what they’re doing wrong. <b>Which sites have great designs that you like?</b> Take a look at things like
              layout, colour schemes, typography, photography, and unique tools or features. Try providing a list of links with reference notes for each of them.
            </p>
            <textarea
              className='focus:ring focus:ring-purple-500 shadow border dark:bg-gray-700 dark:border-gray-700 dark:text-indigo-100 rounded w-full py-4 px-5 text-gray-700 leading-tight'
              type='text'
              name='competitors'
              id='competitors'
            />
          </div>
        </section>
        <hr className='my-8 dark:border-gray-700' />
        <section className='space-y-4'>
          <label className='block text-lg' htmlFor='feel'>
            <h3 className='block'>What's your ideal look &amp; feel</h3>
          </label>
          <div className='prose dark:prose-invert min-w-full md:grid md:grid-cols-2 md:gap-6'>
            <p>
              Following on from looking at your competitors, think about <b>how you'd like the site to look &amp; feel</b>. Pay attention to any nice user interface features you like. Do you like
              lifestyle photography or illustrations? How much of a free reign do you want our designers to have?
            </p>
            <textarea
              className='focus:ring focus:ring-purple-500 shadow border dark:bg-gray-700 dark:border-gray-700 dark:text-indigo-100 rounded w-full py-4 px-5 text-gray-700 leading-tight'
              type='text'
              name='feel'
              id='feel'
            />
          </div>
        </section>
        <hr className='my-8 dark:border-gray-700' />
        <section className='space-y-4'>
          <label className='block text-lg' htmlFor='tech-requirements'>
            <h3 className='block'>Any technical features &amp; requirements</h3>
          </label>
          <div className='prose dark:prose-invert min-w-full md:grid md:grid-cols-2 md:gap-6'>
            <p>
              This section is <b>very important for larger projects</b>. In order to avoid scope creep later into the project (and additional costs) be as thorough as you can here:
              <ul>
                <li>
                  Does the site feature user logins? How will registrations be handled, authorised, and managed? What will be on the user dashboard? Describe every single bespoke feature that will be
                  required.
                </li>
                <li>
                  Is the site e-commerce? If so, describe product categories and variations, payment/checkout methods required, shipping cost calculations, shipping tracking, discount codes, any
                  referral discounts, etc
                </li>
                <li>API Integration – Will the site need to integrate with any external feeds or APIs – if so, we’ll need thorough detail and actual examples of these.</li>
                <li>User profiles – What data will be included? What search criteria?</li>
                <li>Established institutions may have in-house coding guidelines – we’ll need to see these.</li>
              </ul>
              Also list the general areas of the site that will be required such as:
              <ul>
                <li>News/Blog</li>
                <li>Social media feeds</li>
                <li>Discussion Forum</li>
                <li>Interactive Map</li>
                <li>Events section</li>
                <li>Online Bookings</li>
                <li>Portfolio Section</li>
                <li>Team Page</li>
              </ul>
            </p>
            <textarea
              className='focus:ring focus:ring-purple-500 shadow border dark:bg-gray-700 dark:border-gray-700 dark:text-indigo-100 rounded w-full py-4 px-5 text-gray-700 leading-tight'
              type='text'
              name='tech-requirements'
              id='tech-requirements'
            />
          </div>
        </section>
        <hr className='my-8 dark:border-gray-700' />
        <section className='space-y-4'>
          <label className='block text-lg' htmlFor='inhouse'>
            <h3 className='block'>In-house requirements</h3>
          </label>
          <div className='prose dark:prose-invert min-w-full md:grid md:grid-cols-2 md:gap-6'>
            <p>
              Describe <b>how the site will be managed</b> on a day-to-day basis. How regularly will you be updating and adding content? Will any form of data export be required from the site? Other
              than standard Google Analytics, do you need to gather any more ongoing data from the site?
            </p>
            <textarea
              className='focus:ring focus:ring-purple-500 shadow border dark:bg-gray-700 dark:border-gray-700 dark:text-indigo-100 rounded w-full py-4 px-5 text-gray-700 leading-tight'
              type='text'
              name='inhouse'
              id='inhouse'
            />
          </div>
        </section>
        <hr className='my-8 dark:border-gray-700' />
        <section className='space-y-4'>
          <label className='block text-lg' htmlFor='content'>
            <h3 className='block'>Your site content</h3>
          </label>
          <div className='prose dark:prose-invert min-w-full md:grid md:grid-cols-2 md:gap-6'>
            <p>
              Will you be <b>providing new content</b> for the site? If so, it will be a good idea at this point to plot a rough sitemap in your brief. How many pages will there be in total? Be clear
              on who makes up the team for producing this content, and what the approval process is. Supply of content is very often a sticking point in delaying website launches, so start considering
              this from day 1. What photography, illustrations or graphics are currently available?
            </p>
            <textarea
              className='focus:ring focus:ring-purple-500 shadow border dark:bg-gray-700 dark:border-gray-700 dark:text-indigo-100 rounded w-full py-4 px-5 text-gray-700 leading-tight'
              type='text'
              name='content'
              id='content'
            />
          </div>
        </section>
        <hr className='my-8 dark:border-gray-700' />
        <section className='space-y-4'>
          <label className='block text-lg' htmlFor='hosting'>
            <h3 className='block'>Hosting, support &amp; maintenance considerations</h3>
          </label>
          <div className='prose dark:prose-invert min-w-full md:grid md:grid-cols-2 md:gap-6'>
            <p>
              Typically you’ll want your agency to host the site for you, alternatively, you may have other <b>hosting arrangements</b> – please detail these. How much <b>ongoing support</b> do you
              think will be required for the site? What might you need help with moving forward? (Any modern hosting setup should be secure, provide regular backups, and most of all provide a website
              that is fast)
            </p>
            <textarea
              className='focus:ring focus:ring-purple-500 shadow border dark:bg-gray-700 dark:border-gray-700 dark:text-indigo-100 rounded w-full py-4 px-5 text-gray-700 leading-tight'
              type='text'
              name='hosting'
              id='hosting'
            />
          </div>
        </section>
        <hr className='my-8 dark:border-gray-700' />
        <section className='space-y-4'>
          <label className='block text-lg' htmlFor='SEO'>
            <h3 className='block'>Online marketing &amp; SEO strategy</h3>
          </label>
          <div className='prose dark:prose-invert min-w-full md:grid md:grid-cols-2 md:gap-6'>
            <p>
              So you finally set your amazing new website live, and you don’t get a single visit all year – because nobody knows it’s there. <b>Digital marketing is absolutely vital</b> to the success
              of your new website. If you already have marketing plans in place, it can be helpful to summarise them.
            </p>
            <input
              className='focus:ring focus:ring-purple-500 shadow border dark:bg-gray-700 dark:border-gray-700 dark:text-indigo-100 rounded w-full py-4 px-5 text-gray-700 leading-tight'
              type='text'
              name='SEO'
              id='SEO'
            />
          </div>
        </section>
        <hr className='my-8 dark:border-gray-700' />
        <section className='space-y-4'>
          <label className='block text-lg' htmlFor='deadline'>
            <h3 className='block'>Any Deadline?</h3>
          </label>
          <div className='prose dark:prose-invert min-w-full md:grid md:grid-cols-2 md:gap-6'>
            <p>
              Sometimes a <b>timescale</b> might not be of importance – and the project can take as much time as it needs to get right. In other cases, there might be an absolutely vital deadline.
            </p>
            <textarea
              className='focus:ring focus:ring-purple-500 shadow border dark:bg-gray-700 dark:border-gray-700 dark:text-indigo-100 rounded w-full py-4 px-5 text-gray-700 leading-tight'
              type='date'
              name='deadline'
              id='deadline'
            />
          </div>
        </section>
        <hr className='my-8 dark:border-gray-700' />
        <section className='space-y-4'>
          <label className='block text-lg' htmlFor='budgets'>
            <h3 className='block'>What is your Budget?</h3>
          </label>
          <div className='prose dark:prose-invert min-w-full md:grid md:grid-cols-2 md:gap-6'>
            <p>
              Include guideline budgets so that we can <b>plan how your money can best be spent</b> to achieve your website goals.
            </p>
            <textarea
              className='focus:ring focus:ring-purple-500 shadow border dark:bg-gray-700 dark:border-gray-700 dark:text-indigo-100 rounded w-full py-4 px-5 text-gray-700 leading-tight'
              type='text'
              name='budgets'
              id='budgets'
            />
          </div>
        </section>
        <hr className='my-8 dark:border-gray-700' />
        <section className='space-y-4'>
          <h3 className='block'>Lastly, your contact details and we'll get cracking on our side.</h3>
          <div>
            <label className='block text-lg mb-3' htmlFor='name'>
              What's your name? <sup className='text-indigo-600'>*</sup>
            </label>
            <input
              className='focus:ring focus:ring-purple-500 shadow border dark:bg-gray-700 dark:border-gray-700 dark:text-indigo-100 rounded w-full py-4 px-5 text-gray-700 leading-tight'
              type='text'
              name='name'
              id='name'
              required
            />
          </div>
          <div>
            <label className='block text-lg mb-3' htmlFor='email'>
              What's your email address? <sup className='text-indigo-600'>*</sup>
            </label>
            <input
              className='focus:ring focus:ring-purple-500 shadow border dark:bg-gray-700 dark:border-gray-700 dark:text-indigo-100 rounded w-full py-4 px-5 text-gray-700 leading-tight'
              type='email'
              name='email'
              id='email'
              required
            />
          </div>
        </section>
        <div className='mt-6 block sm:inline-block'>
          <div>
            <ReCAPTCHA sitekey={process.env.GATSBY_SITE_RECAPTCHA_KEY} />
          </div>
          <button type='submit' className='button w-full sm:w-auto'>
            Send your Brief
          </button>
        </div>
      </form>
    </section>
  )
}

export default DesignBrief
